// extracted by mini-css-extract-plugin
module.exports = {"settContainer":"common_settContainer_1kefn","label":"common_label_VD_Hs","card":"common_card_5wNKJ","disabled":"common_disabled_1J7nv"};